import { Container, Grid } from '@mui/material';
import { useRouter } from 'ui-sdk/src/router';
import React from 'react';
import { TextColor, theme } from 'ui-sdk/src/theme';
import { MarbleText } from 'src/base/texts/Text';
import { MarbleButton } from 'src/base';

export default function CallToAction({
  cardless = false,
  setup = false,
  color = 'black' as TextColor,
  title = 'Want to learn more?',
  caption = 'Create your account for free and start setting up your rental for Marble Management.',
}): JSX.Element {
  const router = useRouter();
  return (
    <Container style={{ marginTop: theme.spacing(12) }}>
      <Grid container>
        <Grid
          item
          md
          style={{
            marginTop: 'auto',
            marginBottom: 'auto',
            textAlign: 'left',
            alignContent: 'center',
          }}
        >
          <MarbleText size="h2" color={color} style={{ margin: 0 }}>
            {title}
          </MarbleText>
          <MarbleText
            size="l"
            color={color}
            style={{ marginTop: theme.spacing(2) }}
          >
            {caption}
          </MarbleText>
          <div
            style={{
              paddingTop: theme.spacing(2),
              // maxWidth: 200,
              // alignSelf: 'center'
            }}
          >
            <MarbleButton
              title={setup ? 'Get Started' : 'Try for Free'}
              onClick={() => {
                router.push('/start');
              }}
              style={{
                padding: theme.spacing(2),
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4),
                fontWeight: 600,
              }}
            />
            {cardless && (
              <MarbleText
                weight="med"
                style={{
                  marginTop: theme.spacing(1),
                  textAlign: 'left',
                  maxWidth: 400,
                }}
              >
                No credit card required
              </MarbleText>
            )}
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}
